<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title">
      {{'Confirm Logout' | translate}}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>{{ Message | translate}}</div>
    <button
      type="button"
      class="btn btn-sm btnDelete mr-2"
      (click)="confirm(true)"
    >
      {{'Yes' | translate}}
    </button>
    <button type="button" class="btn btn-sm btnCancel" (click)="confirm(false)">
      {{'No' | translate}}
    </button>
  </div>
</ng-template>
